import React from 'react'

import { ModeComment as ModeCommentIcon } from '@mui/icons-material'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '2px'
  },
  icon: {
    fontSize: '2.5em',
  },
  count: {
    position: 'absolute',
    lineHeight: 1,
    color: theme.palette.text.primary,
    top: '0.3em',
    fontSize: '1.4em',
    textShadow: theme.shadows[1],
  }
}))

export default ({ size = 8, count = 10 }) => {
  const classes = useStyles()
  const comments = count < 100 ? count : '99+'
  return (
    <div className={classes.root} style={{ fontSize: size }}>
      <ModeCommentIcon color="primary" className={classes.icon} />
      <Typography component="span" className={classes.count}>
        {comments}
      </Typography>
    </div>
  )
}
